import EventBus from "@/events/bus";
import { subscribe as subscribeModules } from "@/events/modules";

export const EventBusPlugin = {
  install(Vue) {
    const bus = new EventBus();
    Vue.prototype.$bus = bus;
    window.$bus = bus;
    subscribeModules();
  },
  unbind() {
    console.info("Unbinding EventBusPlugin");
  },
};
